import { themeUi } from '../../themeUi/themeUi';

const tabs = {
  tabList: {
    borderBottom: `4px solid ${themeUi.semantic.color.border.neutral600}`,
    secondary: {
      borderTop: themeUi.semantic.color.border.primary100,
      borderInlineEnd: themeUi.semantic.color.border.primary100
    }
  },
  link: {
    selectedBorderBottom: `4px solid ${themeUi.semantic.color.border.primary600}`,
    color: themeUi.semantic.color.text.neutral600,
    hoverColor: themeUi.semantic.color.text.primary600,
    selectedColor: themeUi.semantic.color.text.primary600
  }
};

export default tabs;
